import { render, staticRenderFns } from "./category_min.vue?vue&type=template&id=b6a6f046"
import script from "./category_min.vue?vue&type=script&lang=js"
export * from "./category_min.vue?vue&type=script&lang=js"
import style0 from "./category_min.vue?vue&type=style&index=0&id=b6a6f046&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports